import React from 'react';

import { useTranslation } from 'react-i18next';

import { TWidgetPlan, TPaymentMethodType } from '@entities/widget-shop/model/types';
import { formatPrice } from '@shared/helpers';
import { Checkbox, Flex, UiButton, UiText } from '@shared/ui';

import cls from '../../PaymentWidgetModal.module.css';

interface IPaymentSummary {
    paymentPeriodInfo: TWidgetPlan;
    activePaymentMethodType: TPaymentMethodType;
    autoRenewal: boolean;
    toggleAutoRenewal: () => void;
    currency: string;
    actionBtnHandler?: () => void | undefined;
    isActionBtnPending?: boolean;
}

export const PaymentSummary = ({
    paymentPeriodInfo,
    activePaymentMethodType,
    autoRenewal,
    toggleAutoRenewal,
    currency,
    actionBtnHandler,
    isActionBtnPending = false,
}: IPaymentSummary) => {
    const { t } = useTranslation();
    const isByBankCard = activePaymentMethodType === 'card';
    const isByInvoice = activePaymentMethodType === 'invoice';

    const getBtnText = () => {
        if (isByBankCard) {
            return t('WidgetShop.paymentModal.summary.btnText.ByBank');
        }
        if (isByInvoice) {
            return t('WidgetShop.paymentModal.summary.btnText.ByInvoice');
        }
        return t('WidgetShop.paymentModal.summary.btnText.ByBank');
    };
    return (
        <div className={cls.paymentSummaryBlock}>
            <UiText variant="boldPlain" weight="medium" tag="span">
                {t('WidgetShop.paymentModal.summary.text')} {formatPrice(paymentPeriodInfo?.price)}{' '}
                {currency}
            </UiText>
            <Flex justify="between" className={cls.economyBlock}>
                <UiText variant="mediumPlain" tag="span" className={cls.economySpanText}>
                    {t('WidgetShop.paymentModal.summary.saving')}
                </UiText>
                <UiText variant="mediumPlain" tag="span" className={cls.economySpanValue}>
                    {formatPrice(paymentPeriodInfo?.priceSaving)} {currency}
                </UiText>
            </Flex>
            <UiButton
                btnText={getBtnText()}
                className={cls.payBtn}
                onClick={actionBtnHandler}
                disabled={isActionBtnPending}
            />
            {isByBankCard && (
                <Checkbox
                    isActive={autoRenewal}
                    title={t('WidgetShop.paymentModal.summary.autoRenewal.checkbox.label')}
                    onClick={toggleAutoRenewal}
                />
            )}
        </div>
    );
};
